import type { PropsWithChildren } from "react";
import { createContext, useMemo } from "react";

import { useNonNullableContext } from "app/common";
import type { IDurationData } from "app/services/DurationService";
import DurationService from "app/services/DurationService";

import { useAlertsParams } from "../hooks/useAlertsParams";

const DurationContext = createContext<IDurationData | null>(null);
DurationContext.displayName = "DurationContext";

export const DurationContextProvider = ({ children }: PropsWithChildren) => {
    const params = useAlertsParams();

    const duration = useMemo(() => DurationService.getDurationData(params.duration), [params.duration]);

    return <DurationContext.Provider value={duration}>{children}</DurationContext.Provider>;
};

export const useDurationContext = () => useNonNullableContext(DurationContext);
